import {Component} from '@angular/core';
import {BasePatientPage} from "../../base-patient-page";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";

/** The payment information for a patient */
@Component({
	selector: 'app-payment',
	imports: [
		FormsModule,
		MatCheckboxModule
	],
	templateUrl: './payment.component.html',
	styleUrl: './payment.component.scss'
})
export class PaymentComponent extends BasePatientPage {

	async completeAll() {
		await this.completeCategory(this.controller.payment);
	}
}
